export const SET_IS_LOADING = 'SCHEDULING_SERVICES/SET_IS_LOADING';
export const SET_SCHEDULING_SERVICES = 'SCHEDULING_SERVICES/SET_SCHEDULING_SERVICES';
export const CLEAR_SCHEDULING_SERVICES = 'SCHEDULING_SERVICES/CLEAR_SCHEDULING_SERVICES';